module.exports = __webpack_public_path__ + "img/greece-icon-m.e5be22a.png";